import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Menu, X } from "lucide-react";
import { useState } from "react";
import InstallPWA from "@/components/InstallPWA";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = () => { logout(); nav("/"); setOpen(false); };

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#070707]/70 border-b border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="font-bebas text-3xl md:text-4xl tracking-tight text-white hover:text-[#D4FF00] transition-colors">
          CRIA<span className="text-[#D4FF00]">.</span>FINANCE
        </Link>

        <button data-testid="mobile-menu-toggle" aria-label="Abrir menu" className="text-white/80 hover:text-[#D4FF00] transition-colors" onClick={() => setOpen(!open)}>
          {open ? <X size={26}/> : <Menu size={26}/>}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/[0.06] bg-[#070707]/95 backdrop-blur-xl px-4 md:px-8 py-6 flex flex-col gap-4 font-manrope text-sm uppercase tracking-[0.18em] font-semibold">
          <Link to="/cursos" data-testid="mnav-cursos" onClick={()=>setOpen(false)} className="text-white/70 hover:text-[#D4FF00] transition-colors">Cursos</Link>
          {user && <Link to="/dashboard" data-testid="mnav-dashboard" onClick={()=>setOpen(false)} className="hover:text-[#CCFF00]">Dashboard</Link>}
          {user && <Link to="/missao" data-testid="mnav-missao" onClick={()=>setOpen(false)} className="hover:text-[#CCFF00]">Missão</Link>}
          {user && <Link to="/conquistas" data-testid="mnav-conquistas" onClick={()=>setOpen(false)} className="hover:text-[#CCFF00]">Conquistas</Link>}
          {user && <Link to="/ranking" data-testid="mnav-ranking" onClick={()=>setOpen(false)} className="hover:text-[#CCFF00]">Ranking</Link>}
          {user && <Link to="/dashboard" data-testid="mnav-dashboard" onClick={()=>setOpen(false)} className="text-white/70 hover:text-[#D4FF00] transition-colors">Dashboard</Link>}
          {user && <Link to="/missao" data-testid="mnav-missao" onClick={()=>setOpen(false)} className="text-white/70 hover:text-[#D4FF00] transition-colors">Missão</Link>}
          {user && <Link to="/conquistas" data-testid="mnav-conquistas" onClick={()=>setOpen(false)} className="text-white/70 hover:text-[#D4FF00] transition-colors">Conquistas</Link>}
          {user && <Link to="/ranking" data-testid="mnav-ranking" onClick={()=>setOpen(false)} className="text-white/70 hover:text-[#D4FF00] transition-colors">Ranking</Link>}
          {user?.subscription_active && <Link to="/coach" data-testid="mnav-coach" onClick={()=>setOpen(false)} className="text-white/70 hover:text-[#D4FF00] transition-colors">Coach AI</Link>}
          {user?.is_admin && <Link to="/admin" data-testid="mnav-admin" onClick={()=>setOpen(false)} className="text-[#FF2A6D] hover:text-[#D4FF00] transition-colors">Admin</Link>}
          <div className="pt-3 mt-1 border-t border-white/[0.06]"><InstallPWA/></div>
          {!user ? (
            <>
              <Link to="/login" data-testid="mnav-login" onClick={()=>setOpen(false)} className="text-white/70 hover:text-[#D4FF00] transition-colors">Entrar</Link>
              <Link to="/register" data-testid="mnav-register" onClick={()=>setOpen(false)} className="brutal-btn w-full mt-1">Cadastrar</Link>
            </>
          ) : (
            <button data-testid="mbtn-logout" onClick={doLogout} className="flex items-center gap-2 text-white/70 hover:text-[#FF2A6D] transition-colors">
              <LogOut size={16} /> Sair
            </button>
          )}
        </div>
      )}
    </header>
  );
};
